/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FanRemixContestEndingSoonNotificationActionData
 */
export interface FanRemixContestEndingSoonNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestEndingSoonNotificationActionData
     */
    entityUserId: string;
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestEndingSoonNotificationActionData
     */
    entityId: string;
}

/**
 * Check if a given object implements the FanRemixContestEndingSoonNotificationActionData interface.
 */
export function instanceOfFanRemixContestEndingSoonNotificationActionData(value: object): value is FanRemixContestEndingSoonNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "entityUserId" in value && value["entityUserId"] !== undefined;
    isInstance = isInstance && "entityId" in value && value["entityId"] !== undefined;

    return isInstance;
}

export function FanRemixContestEndingSoonNotificationActionDataFromJSON(json: any): FanRemixContestEndingSoonNotificationActionData {
    return FanRemixContestEndingSoonNotificationActionDataFromJSONTyped(json, false);
}

export function FanRemixContestEndingSoonNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FanRemixContestEndingSoonNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entityUserId': json['entity_user_id'],
        'entityId': json['entity_id'],
    };
}

export function FanRemixContestEndingSoonNotificationActionDataToJSON(value?: FanRemixContestEndingSoonNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_user_id': value.entityUserId,
        'entity_id': value.entityId,
    };
}

